<template>
  <div class="contain">
    <!-- 订单状态 -->
    <van-sticky>
      <van-tabs @click="getState" v-model="status" title-active-color="#f36e86">
        <van-tab
          v-for="(item, index) in tabList"
          :title="item.name"
          :key="index"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>
    <!-- 订单列表 -->
    <div class="box">
      <van-list
        v-model="loading"
        offset="10"
        :finished="finished"
        finished-text="没有更多了 ~"
        @load="onLoad"
        :immediate-check="false"
      >
        <div v-for="(item, index) in List" :key="index">
          <div class="card">
            <van-row>
              <van-col span="12" class="orderType">
                <span v-if="item.status == 1">等待买家付款</span>
                <span v-if="item.status == 2">已付款</span>
                <span v-if="item.status == 3">待取货</span>
                <span v-if="item.status == 4">待归还</span>
                <span v-if="item.status == 5">待结算</span>
                <span v-if="item.status == 6">已完成</span>
                <span v-if="item.status == 7">已取消</span>
              </van-col>
              <van-col
                span="12"
                class="orderTime"
                v-if="item.status == 1 && item.createTime == 0"
                >已失效</van-col
              >
              <van-col
                span="12"
                class="orderTime"
                v-if="item.status == 1 && item.createTime != 0"
              >
                <view style="display: flex; justify-content: flex-end">
                  <span style="padding-right: 12rpx">还剩</span>
                  <van-count-down
                    :time="item.createTime"
                    format="mm 分 ss 秒"
                    @finish="bindFinish"
                  />
                </view>
              </van-col>
            </van-row>
            <div class="orderID">订单号：{{ item.id }}</div>
            <van-card
              v-for="(j, k) in item.detail"
              :key="k"
              :num="j.buyNumber"
              :price="j.buyIntegral.toFixed(2)"
              :title="j.goodsName"
              :thumb="j.goodsImg"
              :desc="item.remark"
            >
              <!-- <template #tags>
                <van-tag type="primary" v-if="item.status == 1">已下单</van-tag>
                <van-tag type="warning" v-if="item.status == 2">待取货</van-tag>
                <van-tag type="success" v-if="item.status == 3">已完成</van-tag>
                <van-tag type="danger" v-if="item.status == 4">已取消</van-tag>
              </template> -->
              <template #footer>
                <van-button
                  size="small"
                  @click="cancel(item)"
                  v-if="userType == item.userId && item.status == 1"
                  >取消订单</van-button
                >
                <van-button
                  size="small"
                  type="info"
                  @click="receive(item.id)"
                  v-if="storeType == item.storeId && item.status == 1"
                  >接单</van-button
                >
                <van-button
                  type="info"
                  size="small"
                  @click="pickUp(item)"
                  v-if="userType == item.userId && item.status == 2"
                  >取货</van-button
                >
                <van-button type="info" size="small" @click="evaluate(item)"
                  >评价</van-button
                >
                <!-- v-if="
                    userType == item.userId &&
                    item.status == 3 &&
                    item.isComment == 0
                  " -->
              </template>
            </van-card>
          </div>
        </div>
      </van-list>
      <div class="fixed">
        <button class="bottomBtn" @click="evaluateList">我的评价</button>
      </div>
      <!-- 空状态 -->
      <!-- <van-empty v-if="List.length == 0" description="暂无数据" /> -->
    </div>
  </div>
</template>

<script>
import { getOrderList, updateOrder } from "@/api/Hotel";
import { getOpenId, getPlatform, getStoreId, getUrl } from "@/utils/auth";
import { Toast, Dialog } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      tabList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "已下单",
        },
        {
          id: 2,
          name: "待取货",
        },
        {
          id: 3,
          name: "已完成",
        },
        {
          id: 4,
          name: "已取消",
        },
      ],
      status: 0,
      List: [],
      storeType: "",
      page: 1,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 计时结束回调时间 取消订单
    bindFinish(e) {
      // this.cancelOrder1(e.currentTarget.dataset.id)
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.page = this.page + 1;
      this.getOrderList(undefined);
    },
    getState(name, tab) {
      console.log(name, tab);
      this.List = [];
      this.page = 1;
      this.status = name;
      this.getOrderList();
    },
    // 获取订单列表
    getOrderList() {
      getOrderList({
        userId: getOpenId(),
        status: this.status,
        pageSize: 10,
        pageNum: this.page,
        platformId: getPlatform(),
        storeId: getStoreId(),
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          for (let i = 0; i < res.data.data.list.length; i++) {
            const e = res.data.data.list[i];
            // console.log(e.createTime);
            if (e.createTime != "") {
              let nowTime = new Date().getTime(); // 获取当前时间的毫秒数
              let initialDateTime = new Date(e.createTime); // 将字符串转换为 Date 对象
              // 将给定的日期时间加上15分钟
              initialDateTime.setMinutes(initialDateTime.getMinutes() + 15);
              // 将结果转换为时间戳格式（毫秒数）
              let resultTimestamp = initialDateTime.getTime();
              let leftTime = resultTimestamp - nowTime; // 计算剩余时间的毫秒数
              if (leftTime <= 0) {
                // 倒计时结束
                console.log("倒计时结束");
                // console.log(e.status);
                e.createTime = 0;
              } else {
                e.createTime = leftTime;
              }
            }
          }
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },

    // 取消订单
    cancel(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要取消该订单吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 4 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.addUserIntegral(item.totalMoney);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取货
    pickUp(item) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认已收到货了吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: item.id, status: 3 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              this.updUserIntegral(item);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 评价
    evaluate(item) {
      console.log(item);
      this.gotoUrl(
        "/periphery/evaluate/" + item.id + "/" + item.detail[0].goodsId
      );
    },

    // 我的评价 列表
    evaluateList() {
      this.gotoUrl("/periphery/evaluateList/1");
    },
    // 修改对应项目 积分
    updUserIntegral(item) {
      console.log(item.totalMoney, "totalMoney");
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/updStoreIntegral";
      const params = { storeId: item.storeId, integral: item.totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取货成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },

    // 修改对应项目 积分
    addUserIntegral(totalMoney) {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/addUserIntegral";
      const params = { userId: getOpenId(), integral: totalMoney };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          Toast.success("取消成功");
          this.List = [];
          that.getOrderList();
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 接单
    receive(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要接收该订单吗?",
      })
        .then(() => {
          // on confirm
          updateOrder({ id: id, status: 2 }).then((res) => {
            if (res.data.code == 200) {
              console.log(res);
              Toast.success("接单成功");
              this.List = [];
              this.getOrderList();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  created() {
    this.getOrderList();
    this.storeType = getStoreId();
    this.userType = getOpenId();
  },
  mounted() {},
};
</script> 

<style scoped>
.contain {
  background: #f6f6f6;
  min-height: 100vh;
}
/deep/ .van-tabs__nav {
  background: #f6f6f6;
}
/deep/ .van-tab {
  font-size: 14px;
  font-family: PingFang SC;
}

/deep/ .van-tabs__line {
  border-radius: 2px !important;
  background-color: #f36e86;
}

.box {
  padding: 10px 3%;
  /* margin: 20rpx 3%; */
}

/deep/ .van-card {
  background-color: #fff;
  /* border-radius: 8px; */
  /* margin-bottom: 10px; */
  padding: 0;
}

/deep/ .van-card__price-currency {
  /* display: none; */
}

/deep/ .van-card__content {
  padding: 6px 0 0;
  box-sizing: border-box;
}

/deep/ .van-card__title {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #232323;
}

/deep/ .van-card__price {
  /* color: #ffffff; */
}

/deep/ .van-card__price-integer {
  color: #232323;
  font-size: 15px;
  font-family: PingFang SC;
}

/deep/ .van-card__desc {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  max-height: 100px;
  white-space: normal;
}

/deep/ .van-button {
  border-radius: 23px;
  width: 80px;
  font-size: 13px;
  /* padding: 0 16px; */
}

/deep/ .van-list {
  padding-bottom: 100px;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.08);
  z-index: 100;
  text-align: center;
}

.bottomBtn {
  background: #f36e86;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  width: 94%;
  padding: 11.5px 0;
  margin-top: 7.5px;
}

/deep/ .van-tag {
  position: absolute;
  right: -16px;
  top: -8px;
  padding: 0px 4px;
  font-size: 8px;
  border-radius: 0 8px 0 8px;
}

.card {
  border-radius: 8px;
  background-color: #ffffff;
  margin: 0px 0 10px;
  padding: 10px;
}

.orderType {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #232323;
}

.orderTime {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff4d59;
  text-align: right;
}
.orderID {
  color: #999999;
  font-size: 12px;
}

/deep/ .van-card__footer {
  margin-top: 10px;
}

/deep/ .van-button--default {
  color: #f36e86;
  background-color: #fff;
  border: 1px solid #f36e86;
  border: 1px solid #f36e86;
}

/deep/ .van-button--info {
  color: #fff;
  background-color: #f36e86;
  border: 1px solid #f36e86;
}
</style>